import { gql } from "@apollo/client";

export const verifyNewUser = gql`
  mutation VerifyUser($verifyUserId: String!, $otp: String!) {
    verifyUser(id: $verifyUserId, otp: $otp) {
      message
      success
      accessToken
      refreshToken
    }
  }
`;

export const resendOtp = gql`
  mutation ResendOTPByEmail($email: String!) {
    resendOTPByEmail(email: $email) {
      message
    }
  }
`;
